export const logos = [
  {
    id: "rp",
    alt: "Rzeczpospolita Polska",
    // src: "/assets/images/logos/school-site/rp-logo-38x45.svg",
    src: {
      light: "/assets/images/logos/school-site/rp-logo-38x45.svg",
      dark: "/assets/images/logos/school-site/rp-logo-38x45.svg",
    },
    href: null,
    priority: 10,
    external: false,
    visible: {
        desktop: true,
        mobile: true,
        headerTop: true,
    },
    size: "md",
    // opcjonalne nadpisanie rozmiaru
    // height: 43,
    // opcjonalna korekta położenia
    offset: {
      x: 0,
      y: 0,
    },
    tooltip: null
  },
  {
    id: "powiat",
    alt: "Powiat Pilski",
    // src: "/assets/images/logos/school-site/powiat_pilski-logo-39-45.svg",
    src: {
      light: "/assets/images/logos/school-site/powiat_pilski-logo-39-45.svg",
      dark: "/assets/images/logos/school-site/powiat_pilski-logo-39-45.svg",
    },
    href: null,
    priority: 20,
    external: false,
    visible: {
        desktop: true,
        mobile: true,
        headerTop: true,
    },
    size: "md",
    // opcjonalne nadpisanie rozmiaru
    // height: 43,
    // opcjonalna korekta położenia
    offset: {
      x: 0,
      y: 0,
    },
    tooltip: null
  },
  {
    id: "eu",
    alt: "Unia Europejska",
    // src: "/assets/images/logos/school-site/european-union-logo-67-45.svg",
    src: {
      light: "/assets/images/logos/school-site/european-union-logo-67-45.svg",
      dark: "/assets/images/logos/school-site/european-union-logo-67-45.svg",
    },
    href: null,
    priority: 30,
    external: true,
    visible: {
        desktop: true,
        mobile: true,
        headerTop: true,
    },
    size: "md",
    // opcjonalne nadpisanie rozmiaru
    // height: 43,
    // opcjonalna korekta położenia
    offset: {
      x: 0,
      y: 0,
    },
    tooltip: null
  },
  {
    id: "school",
    alt: "Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku",
    src: {
      light: "/assets/images/logos/school-site/ckziu-logo-color-no-backgrd-111-45.svg",
      dark: "/assets/images/logos/school-site/ckziu-logo-bw-no-backgrd-white-111-45.svg",
    },
    href: "/",
    priority: 100,
    external: false,
    visible: {
        desktop: true,
        mobile: true,
        headerTop: true,
    },
    size: "md",
    // opcjonalne nadpisanie rozmiaru
    height: 38,
    // opcjonalna korekta położenia
    offset: {
      x: 0,
      y: 0,
    },
    tooltip: null
  },
  {
    id: "education-platform",
    alt: "Platforma edukacyjna CKZiU",

    src: {
      light: "/assets/images/logos/school-site/edu-platforms/education-platform-light.svg",
      dark: "/assets/images/logos/school-site/edu-platforms/education-platform-dark.svg",
    },

    href: "/ckziu",
    priority: 70,
    external: false,

    visible: {
      desktop: true,
      mobile: true,
      headerTop: false,
    },

    size: "sm",
    height: 19,
    offset: {
      x: 0,
      y: 0,
    },

    tooltip: null,
  },
  {
    id: "instaling",
    alt: "InstaLing",

    src: {
      light: "/assets/images/logos/school-site/edu-platforms/instaling-light.png",
      dark: "/assets/images/logos/school-site/edu-platforms/instaling-dark.png",
    },

    href: "https://instaling.pl/",
    priority: 50,
    external: true,

    visible: {
      desktop: true,
      mobile: true,
      headerTop: false,
    },

    size: "sm",
    height: 24,
    offset: {
      x: 0,
      y: -4,
    },

    tooltip: null,
  },
  {
    id: "teams",
    alt: "Microsoft Teams",

    src: {
      light: "/assets/images/logos/school-site/edu-platforms/teams-light.svg",
      dark: "/assets/images/logos/school-site/edu-platforms/teams-dark.svg",
    },

    href: "https://teams.microsoft.com/",
    priority: 60,
    external: true,

    visible: {
      desktop: true,
      mobile: true,
      headerTop: false,
    },

    size: "sm",
    height: 26,
    offset: {
      x: 0,
      y: -5,
    },

    tooltip: null,
  }
];